import {
    Crown,
    Eye,
    Heart,
    Handshake,
    Star,
    Shield,
    Users,
    Building,
    ThumbsUp,
    Award,
    CheckCircle
} from 'lucide-react';
import SpiracleLogo from '../img/spiracle_logo.png';
import CTA from './Cta';
import WhyChooseUs from './Home/WhyChooseUs';

function AboutUs() {
    const mission = [
        "Provide a Professional, Eco-friendly and Cost effective pest control service to valued customer.",
        "A company that identify, make strategy and resolved your pest problem through technological advancement and training"
    ];

    const vision = [
        "To provide clean, healthy and pest free environment.",
        "To provide Comprehensive protection against pest."
    ];

    const coreValues = [
        { icon: <Heart size={28} className="hob-about-icon" />, title: "Passion" },
        { icon: <Handshake size={28} className="hob-about-icon" />, title: "Accountability and collaboration" },
        { icon: <Star size={28} className="hob-about-icon" />, title: "Excellence" },
        { icon: <Shield size={28} className="hob-about-icon" />, title: "Integrity" },
        { icon: <Users size={28} className="hob-about-icon" />, title: "Respect" }
    ];

    return (
        <>
            <section className="hob-about-hero">
                <div className="hob-about-hero-content">
                    <h1 className="hob-about-title">About Us</h1>
                    <p className="hob-about-subtitle">
                        Professional, Eco-friendly and Cost effective pest management.
                    </p>
                </div>
            </section>

            <section className="hob-aboutus-section">
                <div className="hob-aboutus-container">
                    <div className="hob-aboutus-left">
                        <h2 className="hob-aboutus-heading">About Us</h2>
                        <p className="hob-aboutus-text">
                            We Spiracle Pest Management Services has been delivering professional and Integrated Pest Management services to residential & commercial premises across Mumbai and Suburbs area of Mumbai.
                        </p>
                        <p className="hob-aboutus-text">
                            We are committed to provide a Professional, Eco-friendly and Cost effective service solution for our valued customers with our trained and experienced staff for that we more focus on preventive measures rather than curative measures.
                        </p>
                    </div>

                    <div className="hob-aboutus-right">
                        <div className="hob-aboutus-image-wrapper">
                            <img
                                src={SpiracleLogo}
                                alt="Spiracle Pest Worlds"
                                className="hob-aboutus-image"
                            />

                            <div className="hob-aboutus-float hob-aboutus-top-right">
                                <div className="hob-aboutus-flex">
                                    <Building size={18} />
                                    <span>Mumbai & Suburbs</span>
                                </div>
                                <p className="hob-aboutus-float-desc">
                                    Serving residential and commercial premises.
                                </p>
                            </div>

                            <div className="hob-aboutus-float hob-aboutus-bottom-right">
                                <div className="hob-aboutus-flex">
                                    <ThumbsUp size={18} />
                                    <span>Prevention First</span>
                                </div>
                                <p className="hob-aboutus-float-desc">
                                    Focus on preventive measures over curative ones.
                                </p>
                            </div>

                            <div className="hob-aboutus-float hob-aboutus-center-float">
                                <div className="hob-aboutus-flex">
                                    <Award size={18} />
                                    <span>Eco-friendly Pest Control</span>
                                </div>
                                <p className="hob-aboutus-float-desc">
                                    Professional, eco-friendly and cost effective service.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="hob-about-values">
                <h2 className="hob-about-values-heading">Mission & Vision</h2>
                <div className="hob-about-values-grid hob-about-mv-grid">
                    <div className="hob-about-value-card">
                        <Crown size={32} className="hob-about-icon" />
                        <h3 className="hob-about-value-title">Mission</h3>
                        <ul className="hob-about-value-list">
                            {mission.map((item) => (
                                <li key={item}>
                                    <CheckCircle size={16} />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="hob-about-value-card">
                        <Eye size={32} className="hob-about-icon" />
                        <h3 className="hob-about-value-title">Vision</h3>
                        <ul className="hob-about-value-list">
                            {vision.map((item) => (
                                <li key={item}>
                                    <CheckCircle size={16} />
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </section>

            <section className="hob-about-core">
                <h2 className="hob-about-values-heading">Core Values</h2>
                <div className="hob-about-core-grid">
                    {coreValues.map((value) => (
                        <div className="hob-about-value-card" key={value.title}>
                            {value.icon}
                            <h3 className="hob-about-value-title">{value.title}</h3>
                        </div>
                    ))}
                </div>
            </section>

            <WhyChooseUs />
            <CTA />
        </>
    );
}

export default AboutUs;
